// import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "components/DashboardNavbar";

import { create, updateById } from "services/ShowroomBranches";
import { useNavigate, useParams } from "react-router-dom";
import { useMaterialUIController, setErrorSB, setSuccessSB } from "context";

import { Formik } from "formik";
import * as Yup from "yup";
import useLocale from "context/useLocale";
import ShowroomBranchFormik from "./form";

function ShowroomBranchForm() {
  const locale = useLocale();
  const { showroomId, id } = useParams();
  const [, dispatch] = useMaterialUIController();
  const navigate = useNavigate();

  const submitForm = async (values) => {
    const form = new FormData();
    form.append("name_ar", values.nameAr);
    form.append("name_en", values.nameEn);
    form.append("address_ar", values.addressAr);
    form.append("address_en", values.addressEn);
    form.append("map_link", values.mapLink);
    form.append("phone_number", values.phoneNumber);
    if (values.latitude) {
      form.append("latitude", values.latitude);
    }
    if (values.longitude) {
      form.append("longitude", values.longitude);
    }
    form.append("region_id", values.regionId);
    form.append("city_id", values.cityId);
    if (id) {
      await updateById(showroomId, id, form).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.name.en} branch has been updated`);
          setTimeout(() => {
            navigate(`/dashboard/showroom/${showroomId}/branch/`);
          }, 500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    } else {
      await create(showroomId, form).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.name.en} branch has been created`);
          setTimeout(() => {
            navigate(`/dashboard/showroom/${showroomId}/branch/`);
          }, 1500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {locale("showroomBranchesForm")}
                </MDTypography>
              </MDBox>
              <MDBox p={4}>
                <Formik
                  initialValues={{
                    nameEn: "",
                    nameAr: "",
                    addressEn: "",
                    addressAr: "",
                    phoneNumber: "",
                    mapLink: "",
                    latitude: "",
                    longitude: "",
                    regionId: "",
                    cityId: "",
                  }}
                  onSubmit={async (values) => {
                    await submitForm(values);
                  }}
                  validationSchema={Yup.object().shape({
                    nameEn: Yup.string().required("Field is required"),
                    nameAr: Yup.string().required("Field is required"),
                    addressEn: Yup.string().required("Field is required"),
                    addressAr: Yup.string().required("Field is required"),
                    phoneNumber: Yup.string().required("Field is required"),
                    mapLink: Yup.string().url().required("Field is required"),
                    latitude: Yup.number().notRequired(),
                    longitude: Yup.number().notRequired(),
                    regionId: Yup.string().required("Field is required"),
                    cityId: Yup.string().required("Field is required"),
                  })}
                >
                  <ShowroomBranchFormik />
                </Formik>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ShowroomBranchForm;
